<template>
  <div
    class="page-component-scroll"
    v-infinite-scroll="scrollLoad"
    infinite-scroll-immediate="false"
  >
    <slot></slot>
    <div class="side-bar-video" :style="videoPosition" v-if="is_logined">
      <el-badge
        v-if="undealCount > 0"
        :value="undealCount"
        :max="99"
        class="item"
      >
        <el-button @click="openVideo('wait')" type="primary" circle>
          <i class="iconfont iconIcon-shipin"></i>
        </el-button>
      </el-badge>
      <el-button v-else @click="openVideo()" type="primary" circle>
        <i class="iconfont iconIcon-shipin"></i>
      </el-button>
    </div>
    <el-backtop
      :right="positionData.right"
      :bottom="positionData.bottom"
      :visibility-height="positionData['visibility-height']"
      target=".page-component-scroll"
    ></el-backtop>
  </div>
</template>

<script>
import Vue from "vue";
import { Backtop, Badge, InfiniteScroll } from "element-ui";
Vue.use(Backtop);
Vue.use(Badge);
Vue.use(InfiniteScroll);

import { mapState } from "vuex";

export default {
  name: "side-bar",
  props: {
    position: {
      type: Object,
    },
  },
  computed: {
    ...mapState({
      user_info: (state) => state.user,
      undealCount: (state) => state.undealCount,
    }),
    is_logined() {
      const { user_info } = this;
      return user_info && user_info.mobile;
    },
    positionData() {
      const { position, defaultPosition } = this;

      return Object.assign({}, defaultPosition, position);
    },
    videoPosition() {
      const { positionData } = this;

      return {
        right: positionData.right + "px",
        bottom: positionData.bottom + 60 + "px",
      };
    },
  },
  data() {
    return {
      defaultPosition: {
        right: 40,
        bottom: 200,
        "visibility-height": 200,
      },

      processData: {
        timer: null,
        duration: 3 * 60 * 1000, // 3分钟轮询一次
      },
    };
  },
  created() {},
  mounted() {
    this.checkProcessed();
  },
  methods: {
    openVideo: function (tabs) {
      const { is_logined } = this;

      if (is_logined) {
        this.$util.openVideo(tabs);
      } else {
        this.$util.errorFn("请登录");
      }
    },
    // 登录成功后，轮询保持token活跃， 获取未读消息条数
    checkProcessed: function () {
      var _self = this;

      var undealCount = null;

      try {
        undealCount = JSON.parse(location.getItem("undealCount") || {});
      } catch (error) {}

      if (undealCount && undealCount.t) {
        var now = new Date().getTime();
        if (now - undealCount.t < _self.processData.duration) {
          return;
        }
      }

      this.$util
        .get("kzp_common", "check_processed", { silence: true })
        .then((res) => {
          const { code, data, msg } = res || {};

          if (code === 1) {
            this.$store.commit("changeCount", { count: data, source: "ajax" });
          } else {
            _self.clearIntervalCheck();
          }
        })
        .catch(() => {
          _self.clearIntervalCheck();
        });
    },
    clearIntervalCheck: function () {
      clearInterval(this.processData.timer);
    },
    intervalCheck: function () {
      var _self = this;
      _self.clearIntervalCheck();
      this.processData.timer = setInterval(() => {
        _self.checkProcessed();
      }, _self.processData.duration);

      // 立即执行一遍
      _self.checkProcessed();
    },
    scrollLoad: function () {
      this.$emit("load", {});
    },
  },
  watch: {
    is_logined: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.intervalCheck();
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.page-component-scroll {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-width: 1200px;
  overflow-x: hidden;
  overflow-y: auto;
}

.side-bar-video {
  position: fixed;
  width: 40px;
  height: 40px;
  z-index: 5;

  .el-button {
    padding: 0.04rem;
  }

  .iconfont {
    font-size: 0.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SideBar/SideBar.vue